import { Loading } from 'quasar'
import { boot } from 'quasar/wrappers'
import { computed } from 'vue'
import { LocalStorage } from 'quasar'

export default boot(({ router, store, redirect }) => {
  const user = computed(() => store.getters['user/me'])
  router.beforeEach(async (to, from, next) => {
    if (to.name == 'follow' && from.name != 'detail') {
      LocalStorage.clear('followFilters')
      LocalStorage.clear('queryFollowFilters')
      await store.dispatch('orders/query', {
        sort: 'createdAt desc',
        with: 'orderStatus,company'
      })
    }
    if (to.name == 'requests' && from.name != 'request-detail') {
      LocalStorage.clear('requestsFilters')
      LocalStorage.clear('queryRequestFilters')
      await store.dispatch('requests/query', {
        with: 'quote',
        sort: 'createdAt desc'
      })
    }

    Loading.show()

    let roles = to.meta.roles
    let isVisible = false
    if (user.value.role && roles) {
      isVisible = roles.includes(user.value.role)
    } else {
      isVisible = true
    }
    if (to.meta.auth === false) {
      // document
      //   .querySelector('meta[name=theme-color]')
      //   .setAttribute('content', '#fff')
      if (store.state.auth.isAuthenticated && to.name == 'login') {
        next({ name: 'home' })
        // redirect({ name: 'home' })
        // next()
      } else {
        next()
      }
    } else {
      if (store.state.auth.isAuthenticated) {
        if (isVisible) {
          // if (to.name == 'home') {
          //   document
          //     .querySelector('meta[name=theme-color]')
          //     .setAttribute('content', '#0a2354')
          // } else {
          //   document
          //     .querySelector('meta[name=theme-color]')
          //     .setAttribute('content', '#fff')
          // }
          next()
        } else {
          // next('/')
          next({ name: 'home' })
        }
      } else {
        next({
          name: 'login',
          query: {
            redirect: to.fullPath
          }
        })
        // document
        //   .querySelector('meta[name=theme-color]')
        //   .setAttribute('content', '#fff')
      }
    }
  })

  router.afterEach(() => {
    Loading.hide()
  })
})
